module.exports = __webpack_public_path__ + "img/palace_hotel_pinpoint.3a81cec6.svg";